export const INITIAL_CONFIGURATION_DETAIL = [
  {
    title: "Carry forward Vitals",
    flag: "autoVitalSigns", // "AUTO_VITAL_SIGNS",
    HELP_TEXT: "Vitals will be carried forward if this Flag is ON",
    adv_option_seq_num: null,
  },
  {
    title: "Is Active Entity",
    flag: "activeFlag", // "ACTIVE_FLAG",
    HELP_TEXT:
      "Entity will be active if Flag is ON otherwise Enity will be Deactivated",
    adv_option_seq_num: null,
  },
  {
    title: "Set Billed Stats Without Financial Visit",
    flag: "cashOnly", // "CASH_ONLY",
    HELP_TEXT:
      "This optionis used by Cash Only practices or practices who are doing billing with some 3rd party vendors. By turning On this flag:visit will be set to Billed on clicking Ready to Bill. This should not be turned ON for clients who have EPM",
    adv_option_seq_num: null,
  },
  {
    title: "Enable Medicatin Tab For Chiro",
    flag: "chiroRx", // "CHIRO_RX",
    HELP_TEXT:
      "This optionwill enable Chiro practices to do RX. Medication tab will be visible:f this Flag is ON.",
    adv_option_seq_num: null,
  },
  {
    title: "ICD requried on eRX",
    flag: "icdRequriedOnErx", // "ICD_ERX_REQ",
    HELP_TEXT: "This option will enable ICD to be required for sending eRX.",
    adv_option_seq_num: null,
  },
  {
    title: "Ndc Unit",
    flag: "ndcSameAsUnit", // "NDC_SAME_AS_UNIT",
    HELP_TEXT: "This option displays NDC field in the encounter charges grid.",
    adv_option_seq_num: null,
  },
  {
    title: "Show Growth Chart",
    flag: "showGrowthChart", // "SHOW_GROWTH_CHART",
    HELP_TEXT:
      "This option shows up Growth Chart  for specialities other then Pediatrics. The growth chart is displayed by deafult for Pediatrics.",
    adv_option_seq_num: null,
  },
  {
    title: "Enable Support Center",
    flag: "showSupportCenter", // "SHOW_SUPPORT_CENTER",
    HELP_TEXT:
      "This options hides the Support Center tab if Flag is marked as N.",
    adv_option_seq_num: null,
  },
  {
    title: "Enable Tracker Board",
    flag: "showTrackerBoard", // "SHOW_TRACKER_BOARD",
    HELP_TEXT:
      "This option shows the Tracker Board button if Flag is marked as Y.",
    adv_option_seq_num: null,
  },
  {
    title: "Show CC For Provider Speciality",
    flag: "specialitySpecificCC", // "SPECIALITY_SPECIFIC_CC",
    HELP_TEXT:
      "This option allows user to select only Chief Complaints for provider speciality. In order for this option to work, the speciality of provider and chief complaint should be same.",
    adv_option_seq_num: null,
  },
  {
    title: "Enable System Setup Bar",
    flag: "systemSetupBar", // "SYSTEM_SETUP_BAR",
    HELP_TEXT:
      "This option set the Televisit payment mode like Plan or Patient.",
    adv_option_seq_num: null,
  },
  {
    title: "Tele Visit Payment Mode",
    flag: "teleVisitPaymentMode", // "TELE_VISIT_PAYMENT_MODE",
    HELP_TEXT: "Vitals will be carried forward if this Flag is ON",
    adv_option_seq_num: null,
  },
  {
    title: "Tele Visit Payment Amount",
    flag: "teleVisitPaymentAmount", // "TELE_VISIT_PAYMENT_AMOUNT",
    HELP_TEXT: "This option set the Televisit amount to be charged to patient.",
    adv_option_seq_num: null,
  },
  {
    title: "Portal Wait List",
    flag: "portalWaitlist", // "PORTAL_WAITLIST",
    HELP_TEXT: "Waitlist workflow will be executed from the portal.",
    adv_option_seq_num: null,
  },
  {
    title: "Portal Online Appointment",
    flag: "portalOnlineAppointment", // "PORTAL_ONLINEAPPOINTMENT",
    HELP_TEXT: "Online appointment workflow will be executed from the portal.",
    adv_option_seq_num: null,
  },
  {
    title: "Password Policy",
    flag: "enforcePasswordPolicy", // "ENFORCE_PASSWORD_POLICY",
    HELP_TEXT:
      "All users password should be according to the password criteria.",
    adv_option_seq_num: null,
  },
];

export const INITIAL_SYSTEM_OPTIONS = [
  {
    title: "Auto Downloading",
    flag: "autoDownloading", // "AUTO_DOWNLOADING",
    HELP_TEXT: "Vitals will be carried forward if this Flag is ON",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "Claim Status",
    flag: "autoClaimStatus", // "AUTO_CLAIM_STATUS",
    HELP_TEXT:
      "This option is used by Cash Only practices or practices who are doing billing with some 3rd party vendors. By turning On this flag, visit will be set to Billed on clicking Ready to Bill. This should not be turned ON for clients who have EPM",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "Auto Statement",
    flag: "autoStatement", // "AUTO_STATEMENT",
    HELP_TEXT:
      "This option will enable Chiro practices to do RX. Medication tab will be visible if this Flag is ON.",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "Auto Submission",
    flag: "autoSubmission", // "AUTO_SUBMISSION",
    HELP_TEXT: "This option will enable ICD to be required for sending eRX.",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "Claim Edit",
    flag: "claimEdit", // "CLAIM_EDIT",
    HELP_TEXT:
      "This option turns on Tele Visit bucket in dashboard and enables Televisit flow.",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "Elig Future Days",
    flag: "eligFutureDays", // "ELIG_FUTURE_DAYS",
    HELP_TEXT: "This option displays NDC field in the encounter charges grid.",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "Fax Automation",
    flag: "faxAutomation", // "FAX_AUTOMATION",
    HELP_TEXT:
      "This option shows up Growth Chart  for specialities other then Pediatrics. The growth chart is displayed by deafult for Pediatrics.",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "IS CHIRO",
    flag: "ischiro", // "ISCHIRO",
    HELP_TEXT:
      "This options hides the Support Center tab if Flag is marked as N.",
    adv_option_seq_num: "SYS_OPTION",
  },
  {
    title: "ISPT",
    flag: "ispt", // "ISPT",
    HELP_TEXT:
      "This option shows the Tracker Board button if Flag is marked as Y.",
    adv_option_seq_num: "SYS_OPTION",
  },
];

export const CONFIG_DATA = [
  {
    label: "autoVitalSigns",
    value: "AUTO_VITAL_SIGNS",
  },

  {
    label: "activeFlag",
    value: "ACTIVE_FLAG",
  },

  {
    label: "cashOnly",
    value: "CASH_ONLY",
  },

  {
    label: "chiroRx",
    value: "CHIRO_RX",
  },

  {
    label: "icdRequriedOnErx",
    value: "ICD_ERX_REQ",
  },

  {
    label: "ndcSameAsUnit",
    value: "NDC_SAME_AS_UNIT",
  },
  {
    label: "showGrowthChart",
    value: "SHOW_GROWTH_CHART",
  },

  {
    label: "showSupportCenter",
    value: "SHOW_SUPPORT_CENTER",
  },

  {
    label: "showTrackerBoard",
    value: "SHOW_TRACKER_BOARD",
  },

  {
    label: "specialitySpecificCC",
    value: "SPECIALITY_SPECIFIC_CC",
  },

  {
    label: "enforcePasswordPolicy",
    value: "ENFORCE_PASSWORD_POLICY",
  },

  {
    label: "portalOnlineAppointment",
    value: "PORTAL_ONLINEAPPOINTMENT",
  },

  {
    label: "portalWaitlist",
    value: "PORTAL_WAITLIST",
  },

  {
    label: "teleVisitPaymentAmount",
    value: "TELE_VISIT_PAYMENT_AMOUNT",
  },
  {
    label: "teleVisitPaymentMode",
    value: "TELE_VISIT_PAYMENT_MODE",
  },

  {
    label: "systemSetupBar",
    value: "SYSTEM_SETUP_BAR",
  },
];

export const SYS_OPTION_DATA = [
  {
    label: "autoClaimStatus",
    value: "AUTO_CLAIM_STATUS",
  },

  {
    label: "autoDownloading",
    value: "AUTO_DOWNLOADING",
  },

  {
    label: "autoStatement",
    value: "AUTO_STATEMENT",
  },

  {
    label: "autoSubmission",
    value: "AUTO_SUBMISSION",
  },

  {
    label: "claimEdit",
    value: "CLAIM_EDIT",
  },

  {
    label: "eligFutureDays",
    value: "ELIG_FUTURE_DAYS",
  },

  {
    label: "faxAutomation",
    value: "FAX_AUTOMATION",
  },

  {
    label: "ischiro",
    value: "ISCHIRO",
  },

  {
    label: "ispt",
    value: "ISPT",
  },
];
